import React from 'react';
import styled from 'styled-components';
import Spinner from './spinner';

const SpinnerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CenteredSpinner = (props: React.HTMLAttributes<HTMLDivElement>): JSX.Element => (
  <SpinnerWrapper {...props}>
    <Spinner />
  </SpinnerWrapper>
);

export default CenteredSpinner;
